import { Directive } from '@angular/core';
import { ItemHostComponentBase } from '../ItemHostComponentBase';
import { ItemResultRenderTarget, ItemResultRenderTargetComponents } from './item-result-layout/render-targets/ItemResultRenderTarget';
import { ITEM_RESULT_VIEW_COMPONENT_TOKENS } from '../../types/tokens';

@Directive()
export abstract class ItemResultHostComponentBase extends ItemHostComponentBase {
  protected readonly LayoutTargets = ItemResultRenderTarget;
  protected readonly LayoutComponents = ItemResultRenderTargetComponents;

  constructor() {
    super(ITEM_RESULT_VIEW_COMPONENT_TOKENS);
  }
}
